import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TaxReturnSubType, TaxReturnTypeService, TaxReturnSubTypeService } from "../../../../../swaggerServices";
import { Subscription, forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ConfigStateService } from '../../../config/config-state.service';
import { TenantConfigService } from '../../../../shared/services/tenant-config.service';
import { AddUpdateTaxReturnSubTypeComponent } from './add-update-tax-return-subtype/add-update-tax-return-subtype.component';

declare var $: any;

@Component({
    selector: 'app-tax-return-subtypes',
    templateUrl: './tax-return-subtypes.component.html',
    styleUrls: ['./tax-return-subtypes.component.scss'],
    standalone: false
})

export class TaxReturnSubTypesComponent implements OnInit, OnDestroy {

  @ViewChild('addUpdateTaxReturnSubTypeModal')
  addUpdateTaxReturnSubTypeModal: ElementRef;

  @ViewChild('msgModal')
  msgModal: ElementRef;

  subscriptions: Subscription[] = [];

  taxReturnTypeId: number;
  taxReturnTypeName: string;
  taxReturnSubTypes: TaxReturnSubType[];
  taxReturnTypeSearch: string;
  taxReturnSubTypeSearch: string;

  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  selectedPriorSubTypeIds: number[] = [];
  isProductionMode: boolean;

  constructor(
    private route: ActivatedRoute,
    private typeService: TaxReturnTypeService,
    private config: ConfigStateService,
    private subTypeService: TaxReturnSubTypeService,
    private dialog: MatDialog) {
    this.isProductionMode = environment.production;
  }

  ngOnInit() {
    const s = this.route.params
      .pipe(
        switchMap((params: any) => {
          this.taxReturnTypeId = +params['typeId'];
          let taxReturnTypeApiCall = this.typeService.getTaxReturnTypeById(this.taxReturnTypeId);
          let taxReturnSubTypesApiCall = this.subTypeService.getTaxReturnSubTypesBytype(this.taxReturnTypeId);

          return forkJoin([taxReturnTypeApiCall, taxReturnSubTypesApiCall]);
        }))
      .subscribe(([taxReturnTypes, taxReturnSubTypes]) => {
        this.taxReturnTypeName = taxReturnTypes.type;
        this.taxReturnSubTypes = taxReturnSubTypes.subtypes;
        this.selectedPriorSubTypeIds = this.taxReturnSubTypes.map(tst => tst.priorSubTypeId);
      });
    this.subscriptions.push(s);
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
      })
    );
  };

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  editTaxReturnSubType(taxReturnSubType) {
    this.openAddUpdateTaxReturnSubTypeDialog(taxReturnSubType);
  }

  addTaxReturnSubType() {
    this.openAddUpdateTaxReturnSubTypeDialog(null);
  }

  refresh() {
    const s = this.subTypeService.getTaxReturnSubTypesBytype(this.taxReturnTypeId)
      .subscribe(result => {
        this.taxReturnSubTypes = result.subtypes;
        this.selectedPriorSubTypeIds = this.taxReturnSubTypes.map(tst => tst.priorSubTypeId);
      });
    this.subscriptions.push(s);
  }

  private openAddUpdateTaxReturnSubTypeDialog(taxReturnSubType: TaxReturnSubType | null) {
    this.dialog.open(AddUpdateTaxReturnSubTypeComponent, {
      width: '640px',
      data: {
        taxReturnTypeId: this.taxReturnTypeId,
        taxReturnSubType,
        selectedPriorSubTypeIds: this.selectedPriorSubTypeIds
      },
      autoFocus: 'input',
    }).afterClosed().subscribe(updated => {
      if (updated) {
        this.refresh();
      }
    });
  }

}
